import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = ({ data }) => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work Experience"
				body={
					<div className="works-body">
						{data.map((item, index) => (
							<div className="work" key={index}>
								<img
									src="./company.png"
									alt={item.company}
									className="work-image"
								/>
								<div className="work-content">
									<div className="work-title">{item.company}</div>
									<div className="work-subtitle">
										{item.position}
									</div>
								</div>
								<div className="work-duration">
									{item.duration}
								</div>
							</div>
						))}
					</div>
				}
			/>
		</div>
	);
};

export default Works;
